import { LogicContext } from '../types';

export const setCallbackModeForComponents = async (context: LogicContext) => {
  const controllersDataComponents = Object.entries(
    context.controllersData
  ).flatMap(([key, item]) => item.components);

  const updates = controllersDataComponents.map(([id, entry]) => {
    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          callbackMode: context.callbackMode,
        },
      },
    };
  });

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.BottomNavigation.properties.callbackMode',
          value: context.callbackMode,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.StaticNavigation.properties.callbackMode',
          value: context.callbackMode,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.Layout.properties.callbackMode',
          value: context.callbackMode,
        },
      },
      ...updates,
    ],
  };
};
